module.exports = __webpack_public_path__ + "img/burger.de741009.svg";